const timeout = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const retryFn = async (fn: any, ms = 500) => {
  await timeout(ms)
  return fn()
}
